<template>
  <div>
    <h4>
      <slot name="default"> TITLE </slot>
    </h4>
    <div v-if="$slots.subtitle" class="mt-1 text-sm text-muted-foreground">
      <slot name="subtitle" />
    </div>
  </div>
</template>
<script setup lang="ts"></script>
